import { api } from './api';

export interface TutorTopicResourceDTO {
  id: number;
  nodeId: number;
  resourceType: 'FILE' | 'URL' | 'YOUTUBE';
  title: string;
  url: string | null;
  originalFilename: string | null;
  displayOrder: number;
}

export async function listResources(courseId: number, nodeId: number): Promise<TutorTopicResourceDTO[]> {
  const response = await api.get<{ data: TutorTopicResourceDTO[] }>(
    `/api/tutor/courses/${courseId}/nodes/${nodeId}/resources`
  );
  return response.data.data;
}

export async function addResource(
  courseId: number,
  nodeId: number,
  resourceType: 'URL' | 'YOUTUBE',
  title: string,
  url: string
): Promise<TutorTopicResourceDTO> {
  const response = await api.post<{ data: TutorTopicResourceDTO }>(
    `/api/tutor/courses/${courseId}/nodes/${nodeId}/resources`,
    { resourceType, title, url }
  );
  return response.data.data;
}

export async function uploadFile(
  courseId: number,
  nodeId: number,
  file: File,
  title?: string
): Promise<TutorTopicResourceDTO> {
  const formData = new FormData();
  formData.append('file', file);
  if (title) formData.append('title', title);
  const response = await api.post<{ data: TutorTopicResourceDTO }>(
    `/api/tutor/courses/${courseId}/nodes/${nodeId}/resources/upload`,
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } }
  );
  return response.data.data;
}

export async function deleteResource(
  courseId: number,
  nodeId: number,
  resourceId: number
): Promise<void> {
  await api.delete(`/api/tutor/courses/${courseId}/nodes/${nodeId}/resources/${resourceId}`);
}

export async function reorderResources(
  courseId: number,
  nodeId: number,
  orderedIds: number[]
): Promise<void> {
  await api.patch(
    `/api/tutor/courses/${courseId}/nodes/${nodeId}/resources/reorder`,
    { orderedIds }
  );
}
